import { FeatureGroupType } from '@app/license-management/types/feature-group'
import { LicensePool } from '@app/license-management/types/license-pool'

const LABEL_TITLES: Record<NonNullable<LicensePool['label']>, string> = {
  user: 'User Plan',
  team: 'Team Plan',
  site: 'Site Plan',
  admin: 'Admin SLP Access',
}

export const getLicensePoolTitle = (pool: LicensePool): string => {
  // LicensePools now have a label, use it to get the title
  if (pool.label && LABEL_TITLES[pool.label]) {
    return LABEL_TITLES[pool.label]
  }

  // fallback to featureGroup if label is not present
  const slug = pool.featureGroup?.slug as FeatureGroupType | undefined
  const label = pool.featureGroup?.label
  switch (slug) {
    case FeatureGroupType.USER:
      return 'User Plan'
    case FeatureGroupType.TEAM:
      return pool.divisible ? 'Team Plan' : 'Site Plan'
    case FeatureGroupType.NOT_AVAILABLE:
      return label ?? 'Not available'
    default:
      return label ?? pool.featureGroup?.slug ?? 'Unknown Plan'
  }
}
